import { fetchJSON } from '@eventbrite/http';
import { gettext } from '@eventbrite/i18n';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';

export interface IFetchJSONErrorProps {
    errors: { ['__all__']: string[]; auth_backend: string };
    success: boolean;
}

/* istanbul ignore next */
const _hasInvalidResponse = (response: any) =>
    (has(response, 'success') && !response.success) ||
    (has(response, 'errors') && !isEmpty(response.errors));

/* API to call diferent user actions: LogIn, Signup, Mail Soft Account, Social Action*/
/* istanbul ignore next */
export const fetchAuthentication = (
    url: any,
    { headers, method, ...options }: any = {},
) => {
    let fetchHeaders = headers;

    if (method && method !== 'GET') {
        fetchHeaders = {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            ...headers,
        };
    }

    const fetchOptions = {
        headers: fetchHeaders,
        method: method || 'GET',
        ...options,
    };

    return (
        fetchJSON(url, fetchOptions)
            // Need this catch to handle disconnected/general errors that may occur outside
            // of formed server responses
            .catch(() => {
                throw new Error(
                    gettext(
                        'There was a problem with the server, try again',
                    ).toString(),
                );
            })
            .then((response: any) => {
                if (!response || _hasInvalidResponse(response)) {
                    // Example error
                    // {"errors": {"__all__": ["STAFF_USER_NOT_ALLOWED"], "auth_backend": "SOCIAL"}, "success": false}

                    throw response;
                }

                return response;
            })
            .catch((error: IFetchJSONErrorProps) => {
                throw error;
            })
    );
};
